<template>
  <div class="box">
    <!-- 标题部分 -->
    <div class="header">
      <div class="title">{{ i18n.blockchainexplorer }}</div>
      <div class="search_box">
        <div class="left">
          {{ i18n.AllFilters }}
          <img src="../../image/homePage/path.png" alt="" @click="showQuery = !showQuery" />
          <div class="popup" v-show="showQuery">
            <div class="sjx"></div>
            <div class="popList">
              <div class="list" @click="goOnChainQuery(1)">{{ i18n.address }}</div>
              <div class="list" @click="goOnChainQuery(2)">{{ i18n.transaction }}</div>
              <div class="list" @click="goOnChainQuery(3)">{{ i18n.block }}</div>
            </div>
          </div>
        </div>
        <input type="text" v-model="content" :placeholder="placeholder" @keyup.enter="identifyInputType" />
        <img class="Allsearch" src="../../image/homePage/Allsearch.png" alt="" @click="identifyInputType" />
      </div>
      <div class="desc">{{ i18n.desc }}</div>
    </div>
    <!-- 数量卡片 -->
    <div class="cardList">
      <div class="cardBox">
        <div class="top">
          <div class="list">
            <img src="../../image/homePage/Dynamicsharding.png" alt="" />
            <div class="info">
              <div class="info_top">{{ i18n.Dynamicsharding }}：</div>
              <div class="info_bottom">
                <div class="value-container">
                  <div v-if="!loading">{{ info.move_sliceno_num }} <span class="small-text">(+{{ info.add_move_num }})</span></div>
                  <Loader v-else />
                </div>
              </div>
            </div>
          </div>
          <div class="list">
            <img src="../../image/homePage/Blocks.png" alt="" />
            <div class="info">
              <div class="info_top">{{ i18n.TotalBlock }}：</div>
              <div class="info_bottom">
                <div class="value-container">
                  <div v-if="!loading">{{ info.block_num }}</div>
                  <Loader v-else />
                </div>
              </div>
            </div>
          </div>
          <div class="list">
            <img src="../../image/homePage/address.png" alt="" />
            <div class="info">
              <div class="info_top">{{ i18n.Numberofaddresses }}：</div>
              <div class="info_bottom">
                <div class="value-container">
                  <div v-if="!loading">{{ info.address_num }}</div>
                  <Loader v-else />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="list">
            <img src="../../image/homePage/Staticsharding.png" alt="" />
            <div class="info">
              <div class="info_top">{{ i18n.Staticsharding }}：</div>
            </div>
          </div>
          <div class="list">
            <img src="../../image/homePage/Txns.png" alt="" />
            <div class="info">
              <div class="info_top">{{ i18n.Tradingvolume }}：</div>
              <div class="info_bottom">
                <div class="value-container">
                  <div v-if="!loading">{{ info.block_txns_num }}</div>
                  <Loader v-else />
                </div>
              </div>
            </div>
          </div>
          <div class="list">
            <img src="../../image/homePage/Activeaddress.png" alt="" />
            <div class="info">
              <div class="info_top">{{ i18n.Activeaddress }}：</div>
              <div class="info_bottom">
                <div class="value-container">
                  <div v-if="!loading">{{ info.active_address_num }}</div>
                  <Loader v-else />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 节点数量 -->
    <div class="nodes">
      <div class="node">
        <div class="top">
          <div class="total">
            <div class="desc">{{ i18n.Totalnumberofnodes }}</div>
            <div class="num">
              <div v-if="!loading">{{ info.node_num }}</div>
              <Loader v-else />
            </div>
          </div>
          <div class="newlyAdded">
            <div class="desc">{{ i18n.Addnewnodes }}</div>
            <div class="num">
              <div v-if="!loading">{{ info.add_node_num }}</div>
              <Loader v-else />
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="li">
            <div class="desc">{{ i18n.oneNum }}</div>
            <div class="num">
              <div v-if="!loading">{{ info.level1 }}</div>
              <Loader v-else />
            </div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.twoNum }}</div>
            <div class="num">
              <div v-if="!loading">{{ info.level2 }}</div>
              <Loader v-else />
            </div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.threeNum }}</div>
            <div class="num">
              <div v-if="!loading">{{ info.level3 }}</div>
              <Loader v-else />
            </div>
          </div>
          <div class="li">
            <div class="desc">{{ i18n.fourNum }}</div>
            <div class="num">
              <div v-if="!loading">{{ info.level4 }}</div>
              <Loader v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 信息卡片 -->
    <div class="swiper">
      <div class="swiper-list">
        <div class="list">
          <div class="title">{{ i18n.Tokentotal }}</div>
          <div class="num">
            <div v-if="!loading">
              <span>{{ info.token_num }}</span>
            </div>
            <Loader v-else />
          </div>
          
        </div>
        <div class="list">
          <div class="title">{{ i18n.Tradingvolume }}</div>
          <div class="num">
            <div v-if="!loading">
              <span>{{ info.day_trans }}</span>
            </div>
            <Loader v-else />
          </div>        
        </div>
        <div class="list">
          <div class="title">{{ i18n.consensus }}</div>
          <div class="num">
            <div v-if="!loading">
              <span>{{ info.algorithm }}</span>
            </div>
            <Loader v-else />
          </div>
        </div>
        <div class="list">
          <div class="title">TPS</div>
          <div class="num">
            <div v-if="!loading">
              <span>{{ info.tps }}</span>
            </div>
            <Loader v-else />
          </div>
        </div>
      </div>
    </div>
    <!-- 解锁 -->
    <div class="unlock">
      <div class="box">
        <div class="left">
          <div class="title">Unlock the Power of Web3 Today!</div>
          <div class="desc">Join us on the journey to the decentralized future.</div>
        </div>
        <div class="right" @click="goToken">
          Get Started
          <img src="../../image/homePage/GetStarted.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 分片列表 -->
    <div class="slicenoList">
      <div class="lists">
        <div class="title">{{ i18n.UnlimitedShardingList }}</div>
        <div class="list">
          <ul>
            <li>{{ i18n.Partitionname }}</li>
            <li>{{ i18n.type }}</li>
            <li>{{ i18n.numberofnodes }}</li>
            <li>{{ i18n.TCquantity }}</li>
            <li>{{ i18n.Totalnumberofaddresses }}</li>
            <li>{{ i18n.Numberofactiveaddresses }}</li>
            <li>{{ i18n.Numberoftokens }}</li>
            <li>{{ i18n.time }}</li>
          </ul>
          <div class="ul" v-for="item in SliceList" :key="item.sliceno_name" @click="goShardInformation(item)">
            <div class="li">{{ item.sliceno_name }}</div>
            <div class="li">{{ item.sliceno_type }}</div>
            <div class="li" style="color: #006aff">{{ item.node_num }}</div>
            <div class="li">{{ item.tc_num }}</div>
            <div class="li">{{ item.address_num }}</div>
            <div class="li">{{ item.active_address_num }}</div>
            <div class="li">{{ item.token_num }}</div>
            <div class="li">{{ item.uptime }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue'

export default {
  name: 'HomePage',
  components: {
    Loader,
  },
  data() {
    return {
      SliceList: [],
      info: {},
      content: '',
      showQuery: false,
      placeholder: '',
      loading: true,
    }
  },
  computed: {
    i18n() {
      return this.$t('index')
    },
  },
  watch: {
    '$i18n.locale'(newLang) {
      if (newLang === 'zh-CN') {
        this.placeholder = '按地址/交易哈希/区块搜索'
      } else if (newLang === 'en-US') {
        this.placeholder = 'Search by address/transaction hash/block'
      }
    },
  },
  created() {
    if (this.$i18n.locale === 'zh-CN') {
      this.placeholder = '按地址/交易哈希/区块搜索'
    } else if (this.$i18n.locale === 'en-US') {
      this.placeholder = 'Search by address/transaction hash/block'
    }
  },
  mounted() {
    this.getinfiniteSlice()
    this.getindex()
  },
  methods: {
    getindex() {
      this.loading = true
      this.$axios.post('/index/web/index', {})
        .then((res) => {
          this.info = res.data.data
          this.loading = false
        })
        .catch((error) => {
          // Error is already handled by interceptor, but we need to stop loading
          this.loading = false
          console.error('Failed to fetch index data:', error)
        })
    },
    getinfiniteSlice() {
      this.$axios.post('/index/web/infiniteSlice', {})
        .then((res) => {
          this.SliceList = res.data.data
        })
        .catch((error) => {
          // Error is already handled by interceptor
          console.error('Failed to fetch infinite slice data:', error)
          // Set default empty array to prevent UI issues
          this.SliceList = []
        })
    },
    isHash(value) {
      // const md5Regex = /^0x[a-fA-F0-9]{32}$/ // MD5 哈希值
      // const sha1Regex = /^0x[a-fA-F0-9]{40}$/ // SHA-1 哈希值
      const sha256Regex = /^0x[a-fA-F0-9]{64}$/ // SHA-256 哈希值
      // return md5Regex.test(value) || sha1Regex.test(value) || sha256Regex.test(value)
      return sha256Regex.test(value)
    },
    isValidEthereumAddress(address) {
      const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/
      return ethAddressRegex.test(address)
    },
    isBlockNumber(input) {
      const blockNumberRegex = /^\d+$/ // 非负整数
      return blockNumberRegex.test(input)
    },
    identifyInputType() {
      console.log(this.content)
      if (this.content === '') {
        return false
      } else if (this.isHash(this.content)) {
        console.log('hash')
        this.$router.push({ path: '/OnChainQuery', query: { id: 2, content: this.content } })
        sessionStorage.setItem('key', 4)
        this.$bus.$emit('brotherEvent', 4)
      } else if (this.isValidEthereumAddress(this.content)) {
        this.$router.push({ path: '/OnChainQuery', query: { id: 1, content: this.content } })
        sessionStorage.setItem('key', 4)
        this.$bus.$emit('brotherEvent', 4)
        console.log('ethereum address')
      } else if (this.isBlockNumber(this.content)) {
        this.$router.push({ path: '/OnChainQuery', query: { id: 3, content: this.content } })
        sessionStorage.setItem('key', 4)
        this.$bus.$emit('brotherEvent', 4)
        console.log('block number')
      } else {
        console.log('unknown') // 若不符合任何类别，则标记为未知
        this.content = ''
      }
    },
    goOnChainQuery(num) {
      this.$router.push({ path: '/OnChainQuery', query: { id: num } })
      sessionStorage.setItem('key', 4)
      this.$bus.$emit('brotherEvent', 4)
    },
    goToken() {
      this.$router.push('/TokenList')
      sessionStorage.setItem('key', 2)
    },
    goShardInformation(item) {
      this.$router.push({ path: '/ShardInformation', query: { sliceno: item.sliceno, name: item.sliceno_name } })
    },
  },
}
</script>
<style lang="scss" src="./homepage.scss" scoped>
  .value-container {
    min-width: 50px;
  }
  .small-text {
    font-size: 10px;
    color: #006aff;
  }
</style>
